import React from "react";

const LoyaltyStampsRow = ({
  totalStamps = 8,
  currentStamps = 4,
  cardColor,
  stampIcon,
}) => {
  const stamps = Array.from(
    { length: totalStamps },
    (_, i) => i < currentStamps
  );

  return (
    <div
      className="flex gap-2 p-4 bg-yellow-400 rounded-lg justify-center"
      style={{ background: cardColor }}
    >
      {stamps.map((isFilled, index) => (
        <div
          key={index}
          className={`w-10 h-10 rounded-full flex items-center justify-center shadow ${
            isFilled ? "bg-blue-600" : "bg-white"
          }`}
        >
          <img
            src={stampIcon}
            alt="stamp"
            className={`w-5 h-5 ${
              isFilled ? "invert brightness-0" : "opacity-40"
            }`}
          />
        </div>
      ))}
    </div>
  );
};

export default LoyaltyStampsRow;
